<template>
	<fieldset class="inline-fieldset">
		<legend>{{title}}</legend>
		<inline-input-group>
			<slot></slot>
		</inline-input-group>
	</fieldset>
</template>

<script>
export default {
	props: ['title'],
}
</script>

<style scoped>
fieldset {
	border: unset;
	border-radius: 10px;
	border-width: thin;
	border-style: groove;
	border-color: threedface;
}

legend {
	margin-left: 10px;
	font-size: 12px;
	width: unset;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/InlineFieldset.vue